import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SectionHeader from '@/components/SectionHeader';
import Spinner from '@/components/Spinner';
import { API } from '@/lib/utils';
import { useSEO } from '@/lib/useSEO';
import { ArrowRight, Clock, Tag } from '@phosphor-icons/react';

export default function BlogList() {
  const [posts, setPosts] = useState(null);
  useSEO({
    title: 'Gids — kennisartikelen over noodpakketten',
    description: 'Lees onze diepte-artikelen over noodpakketten, stroomuitval, EHBO-koffers en meer. Praktisch advies voor Nederlandse huishoudens.',
    path: '/gids',
  });
  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(Array.isArray(r.data) ? r.data : [])).catch(console.error);
  }, []);

  return (
    <div data-testid="page-blog-list">
      <section className="border-b border-border bg-card">
        <div className="container py-16 lg:py-24">
          <SectionHeader
            eyebrow="Gids"
            title="Diepte-artikelen voor de Nederlandse prepper"
            description="Praktisch advies, koopgidsen en stap-voor-stap instructies voor noodsituaties — geschreven voor wie níet in een bunker wil leven."
            accent
          />
        </div>
      </section>
      <section className="container py-12 lg:py-16">
        {posts === null ? <Spinner /> : posts.length === 0 ? (
          <div className="text-center text-muted-foreground py-20">Nog geen artikelen.</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {(posts || []).map((post, i) => (
              <Link
                key={post.slug}
                to={`/gids/${post.slug}`}
                data-testid={`blog-card-${post.slug}`}
                className="group bg-card border border-border hover:border-primary rounded-sm overflow-hidden hover:-translate-y-1 transition-all duration-200 hover:shadow-lg flex flex-col animate-fade-up"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="aspect-[16/10] bg-muted overflow-hidden relative">
                  <img
                    src={post.hero_image}
                    alt={post.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3 bg-background/95 text-foreground text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-sm flex items-center gap-1">
                    <Tag size={11} weight="bold" /> {post.category}
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 text-xs text-muted-foreground mb-3">
                    <span>{new Date(post.published_date).toLocaleDateString('nl-NL', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                    <span className="flex items-center gap-1"><Clock size={12} /> {post.reading_time_min} min</span>
                  </div>
                  <h3 className="font-display font-bold text-xl leading-tight mb-3 group-hover:text-primary transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed flex-1">{post.excerpt}</p>
                  <div className="mt-5 text-sm font-semibold text-primary inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    Lees artikel <ArrowRight size={14} weight="bold" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
